import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

const CollapsibleSection = ({
  title,
  children,
  defaultExpanded = true,
  badge = null,
  className = '',
  headerClassName = '',
  icon = null,
}) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className={className}>
      <button
        onClick={() => setExpanded(prev => !prev)}
        className={`w-full flex items-center gap-2 py-2 px-1
          text-left text-xs font-semibold text-slate-600 uppercase tracking-wider
          hover:text-slate-800 transition-colors cursor-pointer select-none
          ${headerClassName}`}
      >
        {expanded
          ? <ChevronDown size={14} className="text-slate-400 flex-shrink-0" />
          : <ChevronRight size={14} className="text-slate-400 flex-shrink-0" />}
        {icon && <span className="flex-shrink-0">{icon}</span>}
        <span>{title}</span>
        {badge && <span className="ml-auto text-[10px] font-normal normal-case tracking-normal">{badge}</span>}
      </button>
      {expanded && (
        <div className="mt-1">
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
